import { Object3D, Vector3 } from 'three';
interface FloatData {
  originPos: Vector3;
  speed: number;
  offset: number;
  amp: number;
}
export class FloatController {
  floatableObjs: Object3D[];
  floatData: FloatData[] = [];
  constructor(floatableObjs: Object3D[]) {
    this.floatableObjs = floatableObjs;
    this.floatableObjs.forEach(obj => {
      const config = obj.name.split('-');
      const speed = config[1]
        ? parseFloat(config[1])
        : Math.random() * 0.5 + 0.5;
      const amp = config[2]
        ? parseFloat(config[2]) * 0.01
        : Math.random() * 0.5 + 0.5;
      this.floatData.push({
        originPos: obj.position.clone(),
        speed,
        amp,
        offset: Math.random() * 1000,
      });
    });
  }
  anim(time: number, delta: number) {
    this.floatableObjs.forEach((obj, i) => {
      obj.position.copy(
        this.floatData[i].originPos
          .clone()
          .add(
            new Vector3(
              0,
              Math.sin(
                (time + this.floatData[i].offset) * this.floatData[i].speed
              ) * this.floatData[i].amp,
              0
            )
          )
      );
    });
  }
}
